import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const questionsRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/getallquestions`;
const filtersRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/getfilterlist`;
const deleteRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/deletequestion`;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then(response => response.json())
    .then(json => json)
    .catch((error) => { throw error })
}

function questionRequestApi ({ filters }) {
  const url = new URL(questionsRequestUrl);
  url.search = new URLSearchParams(filters);
  const request = fetch(url, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* questionRequestFlow (action) {
  try {
    const question = yield call(questionRequestApi, action)
    yield put(Actions.questionSuccess(question))
  } catch (error) {
    yield put(Actions.questionError(error))
  }
}

function filterRequestApi () {
  const request = fetch(filtersRequestUrl, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* filterRequestFlow (action) {
  try {
    const filter = yield call(filterRequestApi, action)
    yield put(Actions.filterSuccess(filter))
  } catch (error) {
    yield put(Actions.filterError(error))
  }
}

function deleteRequestApi ({ id }) {
  const request = fetch(deleteRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ question_id: id }),
  })

  return handleRequest(request)
}
function* deleteRequestFlow (action) {
  try {
    const result = yield call(deleteRequestApi, action);
    yield put(Actions.deleteSuccess(result));
    yield questionRequestFlow(action);
  } catch (error) {
    yield put(Actions.deleteError(error));
  }
}

function* questionWatcher () {
  yield all([
    takeLatest(Constants.QUESTION_REQUEST, questionRequestFlow),
    takeLatest(Constants.FILTER_REQUEST, filterRequestFlow),
    takeLatest(Constants.DELETE_REQUEST, deleteRequestFlow),
  ])
}

export default questionWatcher
